// extracted by mini-css-extract-plugin
export var container = "styles-module__container___DEMCD";
export var innerContainer = "styles-module__innerContainer___lTeqm";
export var river = "styles-module__river___au3lY";
export var shimmer = "styles-module__shimmer___HUqfS";
export var title = "styles-module__title___ma6kr";